import getAngularService from './get_angular_service';

const currencyFormatter = (value: any, symbol: string) => {
  const filter = getAngularService('$filter');
  return value < 0 ? `-${filter('currency')(-value, symbol)}` : filter('currency')(value, symbol);
};

export const formatWithCode = (value: any, symbol: string, code?: string | null): string =>
  `${currencyFormatter(value, symbol)}${code ? ` ${code}` : ''}`;

export default currencyFormatter;
